import Translator from 'translator';
import initMiddlewareSocket from 'data/common/SocketMiddleware';
import getApiInstance from 'data/common/ApiCallGenerique';
import { Toastr } from 'data/common';
import api from './api';

const api_caller = getApiInstance();
const apiCallerGit = getApiInstance('gitlab');

function initialize_app() {
    return (dispatch, getState) => {
        return api_caller
            .call(api.initialize_app())
            .then(({ data }) => {
                if (data.success) {
                    if (typeof data.profile !== 'undefined' && Object.keys(data.profile).length) {
                        localStorage.setItem('session', data.profile.session);
                        dispatch({
                            type: 'LOGIN_USER',
                            user: data.profile
                        });
                        dispatch({
                            type: 'APP_INITIALIZED'
                        });
                    } else throw new Error('general.error.user_has_not_correctly_return_by_server');

                    if (!data.searchCityUrl) Toastr.error(Translator.translate(`api.message.searchCityUrlNotDefined`));

                    if (!data.gitlabUrl || !data.gitlabPrivateToken) Toastr.error(Translator.translate(`api.message.gitlabUrlNotDefined`));
                    else {
                        apiCallerGit.api_url = data.gitlabUrl;
                        apiCallerGit.private_token = data.gitlabPrivateToken;
                    }

                    dispatch({
                        type: 'SET_URL_METEO',
                        searchCityUrl: data.searchCityUrl ? data.searchCityUrl : ''
                    });

                    if (data.configEnvironments) {
                        dispatch({
                            type: `SET_CONFIG_ENVS`,
                            config: data.configEnvironments
                        });
                    }
                    let access_token = localStorage.getItem('access_token');

                    if (access_token) access_token = access_token.replace(/"/g, '');
                    if (typeof data.middleware_config !== 'undefined') {
                        initMiddlewareSocket(dispatch, getState, access_token, data.middleware_config);
                    }

                    return data;
                } else if (data.message) {
                    throw new Error(data.message);
                } else throw new Error(Translator.translate('general.ajax_error'));
            })
            .catch(e => {
                throw e;
            });
    };
}
export { initialize_app };



// WEBPACK FOOTER //
// ./scenes/Splashpage/actions.js